<template>
	<div class="sidebar-item">

		<div class="header">
			<btn s='xs' class="drop-down" :icon="isOpen?'chevron-up':'chevron-double-down'" @press="toggle"/> {{title}} 
		</div> 
		<!-- <inputi type="boolean" size="s" :label="title"/> -->
		<div class="body" v-show="isOpen"><slot/></div>
	</div>
</template>
<script>
	export default {
		name:"sidebar-item",
		props:["title"],
		methods:{
			toggle(){
				this.isOpen=!this.isOpen;
			}
		},
		data(){
			return {
				item:"value",
				isOpen:false
			}
		}
	}
</script>
<style scoped>
	.drop-down{
		padding:2px;
		width:22px;
	}
	.header{
		font-size: 14px;
		padding:0;
		height:24px;
	}
	.sidebar-item{
		background: whitesmoke;
		padding:2px;
		margin:1px;border:1px solid lightgrey;
		
	}
	.body{
		background: white;
		padding:4px;
		text-align: center;

	}
</style>